<script>
	export let cls = null
	export let noborder = 'middle-line'
	export let hideTiming = false
</script>

<div class="grid grid-cols-6 sm:grid-cols-7 {cls}">
	<div class="col-span-1 hidden p-2 sm:block">
		{#if $$slots.timing && !hideTiming}
			<div class="pt-1 text-xs">
				<slot name="timing" />
			</div>
		{/if}
	</div>
	<div class="col-span-1 flex flex-col items-center justify-between pb-10 text-center {noborder}">
		{#if $$slots.num}
			<div
				class="flex h-11 w-11 items-center justify-center rounded-full bg-neutral-900 text-center text-white"
			>
				<slot name="num" />
			</div>
		{/if}
		<slot name="extrasteps" />
	</div>
	<div class="col-span-5 ml-6-res pb-8 pt-0 sm:ml-0">
		{#if $$slots.title}
			<h3 class="unstyled my-2 text-lg font-semibold"><slot name="title" /></h3>
		{/if}
		<slot name="content" />
	</div>
</div>

<style>
	.middle-line {
		background-image: url('/images/icons/gray/dashed_line.webp');
		background-position: center 2em;
		background-repeat: repeat-y;
	}
</style>
